<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/eYPrYS/tc-custom/9781459253025.jpg?1726872491269" alt="This image is the cover for the book Dark Oasis"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Dark Oasis
      </h1>
      <p class="bookDescription body article font2">
        <b><i>A dangerous attraction</i></b><br/><br/>When Kit was stranded in Morocco with no money, her memory a blank, she could only pray for a miracle. And when Gerard Dumont, a gorgeous Frenchman, came to her rescue, Kit was so grateful that it didn't  occur to her he might not be the charming protector he seemed.<br/><br/>It wasn't long before Kit discovered that Gerard had a hidden agenda. But by then it was too late. This brooding stranger had taken over her life, and Kit soon realized he'd also captured her heart!
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Helen Brooks
      </h2>
      
      <p class="authorDescription body article">Helen Brooks began writing in 1990 as she approached her 40th birthday! She realized her two teenage ambitions (writing a novel and learning to drive) had been lost amid babies and hectic family life, so set about resurrecting them. In her spare time she enjoys sitting in her wonderfully therapeutic, rambling old garden in the sun with a glass of red wine (under the guise of resting while thinking of course). Helen lives in Northampton, England with her husband and family.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?0555b3ff